import { useEffect, useState } from 'react'
import { NavLink, Route, Routes, useLocation } from 'react-router-dom'

import { appliquerMiseAJour, onMiseAJour } from '../pwa/register'
import { IconeAccueil, IconeBudget, IconeListe, IconeMenu, IconeStats } from './composants'
import { FournisseurDonnees } from './donnees'
import { PageBilan } from './pages/Bilan'
import { PageBudgets } from './pages/Budgets'
import { PageCategories, PageCategorie } from './pages/Categories'
import { PageComptes, PageCompte } from './pages/Comptes'
import { PageInstallation } from './pages/Installation'
import { PageJustificatif } from './pages/Justificatif'
import { PageModeles, PageModele } from './pages/Modeles'
import { PageOperation } from './pages/Operation'
import { PageOperations } from './pages/Operations'
import { PagePlus } from './pages/Plus'
import { PagePrevisionnel } from './pages/Previsionnel'
import { PageRecurrence, PageRecurrences } from './pages/Recurrences'
import { PageReglages } from './pages/Reglages'
import { PageRemboursements } from './pages/Remboursements'
import { PageStatistiques } from './pages/Statistiques'
import { PageTableauDeBord } from './pages/TableauDeBord'
import { PageTiers, PageTiersListe } from './pages/Tiers'

function BandeauMiseAJour() {
  const [pret, setPret] = useState(false)
  const [enCours, setEnCours] = useState(false)

  useEffect(() => onMiseAJour(setPret), [])

  if (!pret) return null
  return (
    <div className="bandeau-maj" role="status">
      <span className="grandir">Une nouvelle version est prête.</span>
      <button
        type="button"
        className="btn btn--petit"
        disabled={enCours}
        onClick={() => {
          setEnCours(true)
          void appliquerMiseAJour()
        }}
      >
        {enCours ? 'Mise à jour…' : 'Recharger'}
      </button>
    </div>
  )
}

export function App() {
  const location = useLocation()

  return (
    <div className="app">
      <BandeauMiseAJour />
      <FournisseurDonnees>
        {/* Cle sur le chemin : `/operations/nouvelle` et `/operations/:id`
            rendent le meme composant, et React reutiliserait son instance en
            passant directement de l'un a l'autre — avec l'etat du formulaire
            precedent. Une depense privee heritait ainsi en silence de la
            repartition de la fiche d'avant. Un nouveau chemin repart donc
            toujours d'un etat vierge ; les filtres, portes par la query
            string, ne sont pas concernes. */}
        <Routes key={location.pathname}>
          <Route path="/" element={<PageTableauDeBord />} />
          <Route path="/operations" element={<PageOperations />} />
          <Route path="/operations/nouvelle" element={<PageOperation />} />
          <Route path="/operations/:id" element={<PageOperation />} />
          <Route path="/previsionnel" element={<PagePrevisionnel />} />
          <Route path="/budgets" element={<PageBudgets />} />
          <Route path="/statistiques" element={<PageStatistiques />} />
          <Route path="/bilan/:categorieId" element={<PageBilan />} />
          <Route path="/remboursements" element={<PageRemboursements />} />
          <Route path="/justificatif" element={<PageJustificatif />} />
          <Route path="/recurrences" element={<PageRecurrences />} />
          <Route path="/recurrences/:id" element={<PageRecurrence />} />
          <Route path="/comptes" element={<PageComptes />} />
          <Route path="/comptes/:id" element={<PageCompte />} />
          <Route path="/categories" element={<PageCategories />} />
          <Route path="/categories/:id" element={<PageCategorie />} />
          <Route path="/tiers" element={<PageTiersListe />} />
          <Route path="/tiers/:id" element={<PageTiers />} />
          <Route path="/modeles" element={<PageModeles />} />
          <Route path="/modeles/:id" element={<PageModele />} />
          <Route path="/plus" element={<PagePlus />} />
          <Route path="/reglages" element={<PageReglages />} />
          <Route path="/installation" element={<PageInstallation />} />
          <Route path="*" element={<PageTableauDeBord />} />
        </Routes>
      </FournisseurDonnees>

      <nav className="onglets" aria-label="Navigation principale">
        <NavLink to="/" className="onglet" end>
          <IconeAccueil />
          Accueil
        </NavLink>
        <NavLink to="/operations" className="onglet">
          <IconeListe />
          Opérations
        </NavLink>
        <NavLink to="/previsionnel" className="onglet">
          <IconeBudget />
          Budget
        </NavLink>
        <NavLink to="/statistiques" className="onglet">
          <IconeStats />
          Stats
        </NavLink>
        <NavLink to="/plus" className="onglet">
          <IconeMenu />
          Plus
        </NavLink>
      </nav>
    </div>
  )
}
